import { render, staticRenderFns } from "./DaEventDetailDialog.vue?vue&type=template&id=21870364&"
import script from "./DaEventDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./DaEventDetailDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports